import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { ISecurityRolesState, ISecurityRole, ISecurityRolesFilter, getInitialSecurityRolesState } from "./SecurityRoles.state";

const initialState = getInitialSecurityRolesState();

export const securityRoles = createSlice({
  name: "securityRoles",
  initialState: initialState,
  reducers: {
    applyFilter: (state: ISecurityRolesState, action: PayloadAction<ISecurityRolesFilter>) => {
      return {
        ...state,
        filter: { ...state.filter, ...action.payload },
        notifications: []
      };
    },
    loadSecurityRoles: actionProcessing.createWithClearNotification((state: ISecurityRolesState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    loadSecurityRolesCompleted: (state: ISecurityRolesState, action: PayloadAction<ISecurityRole[]>) => {
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    },
    loadSecurityRolesFailed: (state: ISecurityRolesState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
        isLoading: false
      };
    },
    reset: actionProcessing.createWithClearNotification(() => {
      return {
        ...initialState
      };
    }),
    onSelectionChanged: (state: ISecurityRolesState, action: PayloadAction<ISecurityRole[]>) => {
      return {
        ...state,
        selectedRole: action.payload[0]
      };
    }
  },
  extraReducers: { ...getScreenExtraReducers<ISecurityRolesState>("notifications", initialState) }
});
